import React from 'react';
import { Link } from 'react-router-dom';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import CodeOutlinedIcon from '@mui/icons-material/CodeOutlined';
import MotionSection from './ui/MotionSection';

function EngineeringWorkCta() {
  return (
    <MotionSection id="engineering-work">
      <div className="ui-card p-6 sm:p-10 flex flex-col sm:flex-row sm:items-center justify-between gap-6">
        <div className="max-w-xl">
          <p className="ui-eyebrow mb-3">For engineers & hiring managers</p>
          <h2 className="text-2xl sm:text-[1.75rem] font-semibold tracking-[-0.02em] text-ink mb-2">
            Prefer the engineering deep-dive?
          </h2>
          <p className="text-ink-muted leading-relaxed">
            Architecture decisions, tech stack, career timeline, GitHub, and the full technical portfolio live on a separate page.
          </p>
        </div>
        <Link to="/work" className="ui-btn-primary self-start sm:self-auto flex-shrink-0">
          <CodeOutlinedIcon sx={{ fontSize: 18 }} />
          View engineering work
          <ArrowForwardIcon sx={{ fontSize: 16 }} />
        </Link>
      </div>
    </MotionSection>
  );
}

export default EngineeringWorkCta;
